import axios from 'axios';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useFetch from './useFetch';

function BlogDetail() {
    const {id}=useParams();
    const {data:blog,error,isPending}=useFetch('http://localhost:3000/blogs/'+id);
    const navigate=useNavigate()
    const handleClick = ()=>{
        axios.delete("http://localhost:3000/blogs/" + blog.id)
            .then(()=>{
                navigate('/')
            })
    }
    return (
        <div className='blog-details'>
            <h2>Blog Details - {id}</h2>
            {isPending && <div>Loading....</div>}
            {error && <div>{error}</div>}
            { blog && 
            <article>
                <h2>Written By {blog.author}</h2>
                <div>{blog.body}</div>
                <button onClick={handleClick}>Delete</button>
            </article>}
        </div>
    );
}

export default BlogDetail;